import React, { useState, useEffect } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './personInfo.css';
import loading from '../../img/loading.gif';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { Buffer } from 'buffer'
import { createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed, 
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed, 
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed, 
    createCompany,
    showError} from '../ViewCreator';


const cookies = new Cookies();
function CompanyInfo() {

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };


    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }


        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendCompany(id);
    }, []);

    const setViews = (inner) => {
        var a = document.getElementById("viewFull");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    const sendCompany = (id) => {
        var path = ip + '/api/company/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    var pe = createCompany(pers)
                    zz.push(pe)

                    if(pers.photos.length>0){
                        var adr = document.createElement('div');
                        adr.innerHTML = "<br><hr>Фото:";
                        zz.push(adr)
                        var inner = document.createElement('div');
                        inner.className = 'prevInner'
                        for (let index = 0; index < pers.photos.length; index++) {
                          var d = document.createElement('div');
                          d.className = 'prevView'
                          var element = new Image();
                          element.src = loading
                            element.className = 'prevImageSearchEmpty'
                            element.id = 'image'+pers.photos[index].id
                            getAvatar(pers.photos[index].id, 'prevImage')
      
                          d.appendChild(element)
                            //img.source = {uri: base64Image}
      
                            if (pers.photos[index].text != undefined){
                              var t = document.createElement('div');
                              
                            t.innerHTML = pers.photos[index].text
                            d.appendChild(t)
                            }
                          inner.appendChild(d)
                        }
                        zz.push(inner)
                      }

                    if (pers.persons.length > 0) {
                        var adr = document.createElement('div');
                        adr.innerHTML = "<br><hr>Зв'язки:";
                        zz.push(adr)
                        for (let index = 0; index < pers.persons.length; index++) {
                            var a = createPersonCollapsed(pers.persons[index].person, index, pers.persons[index].type, pers.persons[index].text, "Р", "З");
                            var i = pers.persons[index].person.id
                            const dblcl = i => () => {
                                sendPersonFullScreen(i)
                            }
                            a.ondblclick = dblcl(pers.persons[index].person.id)
                            zz.push(a)

                        }
                    }

                    if (pers.address.length > 0) {
                        var adr = document.createElement('div');
                        adr.innerHTML = "<br><hr>Адреси:";
                        zz.push(adr)
                        for (let index = 0; index < pers.address.length; index++) {
                            var aaaa = pers.address[index].address
                            var a = createAddressCollapsed(aaaa, index, pers.address[index].type, pers.address[index].text, "Р", "П");
                            zz.push(a)
                            var i = pers.address[index].address.id
                            const dblcl = i => () => {
                                sendAddressFullScreen(i)
                            }
                            a.ondblclick = dblcl(pers.address[index].address.id)
                            zz.push(a)
                        }
                    }
                    
                                    if(pers.auto.length>0){
                                      var adr = document.createElement('div');
                                      adr.innerHTML = "<br><hr>Транспорт:";
                                      zz.push(adr)
                                      for (let index = 0; index < pers.auto.length; index++) {
                                        var a = createAutoCollapsed(pers.auto[index].auto,index,pers.auto[index].type,pers.auto[index].text, "В", "В");
                                          zz.push(a)
                                          var i = pers.auto[index].auto.id
                                          const dblcl = i => () =>{
                                            sendAutoFullScreen(i)
                                        }
                                        a.ondblclick = dblcl(pers.auto[index].auto.id)
                                          zz.push(a)
                                      }
                                    }
                    
                                    if(pers.contacts.length>0){
                                      var adr = document.createElement('div');
                                      adr.innerHTML = "<br><hr>Контакти:";
                                      zz.push(adr)
                                      for (let index = 0; index < pers.contacts.length; index++) {
                                          var a = createContactCollapsed(pers.contacts[index], "З", "О"); zz.push(a)
                                          var i = pers.contacts[index].idContact
                                          const dblcl = i => () =>{
                                            sendContactFullScreen(i)
                                          }
                                          a.ondblclick = dblcl(pers.contacts[index].idContact)
                                          zz.push(a)
                                      }
                                    }
                    
                                    
                                    if(pers.opms.length>0){
                                      var opm = document.createElement('div');
                                      opm.innerHTML = "<br><hr>Заходи:";
                                      zz.push(opm)
                                      for (let index = 0; index < pers.opms.length; index++) {
                                        var a = createOPMCollapsed(pers.opms[index].opm,index,pers.opms[index].type,pers.opms[index].text, "О", "#");
                                          zz.push(a)
                                          var i = pers.opms[index].opm.id
                                          const dblcl = i => () =>{
                                            sendOPMFullScreen(i)
                                        }
                                        a.ondblclick = dblcl(pers.opms[index].opm.id)
                                          zz.push(a)
                                      }
                                    }
                    
                                    
                    
                                  
                    
                                    if(pers.arch.length>0){
                                      var adr = document.createElement('div');
                                      adr.innerHTML = "<br><hr>Файли:";
                                      zz.push(adr)
                                      for (let index = 0; index < pers.arch.length; index++) {
                                          var a = createArchCollapsed(pers.arch[index],index);
                                          
                                          var b = document.createElement('Button');
                                          b.className = "buttonDownload"
                                          b.textContent = "Завантажити"
                    
                                          const cl = i => () =>{
                                            getFile(i.id,i.fileName)
                                            //pp(i)
                                          }
                                          
                                          b.onclick = cl(pers.arch[index].archive)
                    
                    
                    
                                          a.appendChild(b)
                                          zz.push(a)
                                      }
                                    }



                    String.prototype.replaceAt = function (index, replacement) {
                        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
                    }
                    var spr = document.createElement('div');
                    spr.className = "spravka"

                    spr.innerHTML = "<hr><p>" + pers.infoCompany.replace(/\r\n/g, "<p>");
                    zz.push(spr)

                    setViews(zz)

                    if (pers.persons.length > 0) {
                        for (let index = 0; index < pers.persons.length; index++) {
                            if (pers.persons[index].person.image != undefined) {
                                getAvatar(pers.persons[index].person.image, 'prevImageSearch')
                            }
                        }
                    }

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    const sendAddressFullScreen = (id) => {
        window.open("/address?id="+id)
      }
      const sendAutoFullScreen = (id) => {
        window.open("/auto?id="+id)
      }
      const  sendCompanyFullScreen = (id) => {
        window.open("/company?id="+id)
      }
      const  sendContactFullScreen = (id) => {
        window.open("/contact?id="+id)
      }
      const  sendOPMFullScreen = (id) => {
        window.open("/opm?id="+id)
      }
    
    const getAvatar = async (id) => {
        var path = ip + '/files/avatar';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                    a.src = 'data:image/png;base64,' + result.data
                    a.className = 'prevImageSearch'
                }
            })

    }

    const getFile = async(id, fileName) => {
        var path = ip+'/files/file';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);

                    var byteArray = Buffer.from(result.data, "base64"); 
        
                    const blob = new Blob([byteArray],{ type: 'application/octet-binary' });
                    
                                        const link = document.createElement('a');
                                        // Browsers that support HTML5 download attribute
                                        if (link.download !== undefined) {
                                          const url = URL.createObjectURL(blob);
                                          link.setAttribute('href', url);
                                          link.setAttribute('download', fileName);
                                          link.style.visibility = 'hidden';
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }
                }
            })
      }

    const printSubmit = () => {

    }

    const editSubmit = () => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id");
        window.open("/edit/company?id="+id, "_self")
    }

    const trashSubmit = () => {
        Swal.fire({
            title: 'Ви дійсно бажаєте видалити запис',
            //text: "Оновити інформацію?",
            icon: 'question',
            html:
                '',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Видалити',
            denyButtonText: 'Оновити',

            background: '#2B2B2B',
            color: '#FFF'
        }).then((result) => {
            if (result.isConfirmed) {
                removePerson()
            }
        })
    }

    const removePerson = () => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id");
        var path = ip + '/api/company/remove';
        var bd = encryptAes((id))
        const requestOptions = {
          headers: {
            'Content-Type': 'Content-type: text/html'
          },
          credentials: 'include',
          uri: path,
          encoding: 'latin1',
          body: bd,
          method: 'POST'
        };
        fetch(path, requestOptions)
          .then()
          .then(response => { return response.arrayBuffer() })
          .then((buffer) => {
            const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
            const text = decoder.decode(buffer);
            try {
              var result = JSON.parse(text);
              showError(result.msg)
    
            } catch (error) {
              const decryptedText = decryptAes(text);
              var result = JSON.parse(decryptedText);
              storeKey('test_data', result.key);
              Swal.fire({title: 'Видалено', text: '', icon: 'success', timer: 5000 ,background: '#2B2B2B',
                color: '#FFF',
                didClose: (toast) => {
                  window.open("/main","_self")
                }})
              
            }
          })
      }

    return (
        <div className="main">
            <div className="header">
                <img src={logo} className="logo" alt="logo" />
                <div className="title" onClick={mainSubmit}>SPACE</div>
                <div className="subtitle">(info) </div>

                <button className="headerButton" onClick={printSubmit} >
                    <img src={print} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 2} onClick={editSubmit} >
                    <img src={edit} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 1} onClick={trashSubmit} >
                    <img src={trash} className="headerImage" />
                </button>

            </div>


            <div id="viewFull">

            </div>
        </div>
    );
}


export default CompanyInfo;